import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import { useSubmitData } from "../../../../hooks/useSubmitData";
import * as yup from "yup";
import { useSetMenu } from "../../../../hooks/useSetMenu";
import FormLayout from '../../../Generic/FormLayout';
import FormInput from '../../../Generic/FormInput';
import FormCheckbox from '../../../Generic/FormCheckbox';

const Add = () => {
  const { mainStore } = useStore();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  useSetMenu(mainStore.SystemVersionsAdminMenuType, mainStore.SystemVersionsAdminMenuNo);

  const onError = (errors, e) =>
    enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });

  const schema = yup.object({
    versionLabel: yup.string().required(t('requiredField')).max(20, t('maxLength', { max: 20 })),
    nameEN: yup.string().required(t('requiredField')).max(200, t('maxLength', { max: 200 })),
    versionOrder: yup.number().required(t('requiredField')).min(1, t('minValue', { min: 1 })),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      versionOrder: 1,
      isCurrent: false,
      isVisible: true,
    }
  });

  const sendData = useSubmitData(axiosPrivate, "/SystemVersions", "/Admin/SystemVersions");
  const onSubmit = data => sendData(data);
  const onCancel = () => navigate(-1);

  return (
    <FormLayout title={t("systemVersionCreateTitle") || "Add System Version"} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
      <FormInput label="order" name="versionOrder" type="number" register={register} errors={errors} colSize={2} />
      <FormInput label="versionLabel" name="versionLabel" register={register} errors={errors} colSize={3} />
      <FormCheckbox label="isCurrent" register={register} name="isCurrent" colSize={3} />
      <FormInput label="externalUrl" name="externalUrl" register={register} errors={errors} colSize={12} />
      <FormInput label="nameEN" name="nameEN" register={register} errors={errors} colSize={12} />
      <FormInput label="nameBG" name="nameBG" register={register} errors={errors} colSize={6} />
      <FormInput label="nameSQ" name="nameSQ" register={register} errors={errors} colSize={6} />
      <FormInput label="descriptionEN" name="descriptionEN" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionBG" name="descriptionBG" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionSQ" name="descriptionSQ" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormCheckbox label="isVisible" register={register} name="isVisible" colSize={4} />
    </FormLayout>
  );
};

export default Add;
